// EmailJS Configuration
export const EMAILJS_CONFIG = {
  SERVICE_ID: 'service_pgn8nyz',
  TEMPLATE_ID_OWNER: 'template_f4a3vgt',
  TEMPLATE_ID_USER: 'template_xlf11v3',
  PUBLIC_KEY: 'OMQRjH8bIcwH_Jd9S',
}; 